"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var DrawerEventsManagerService = /** @class */ (function () {
    function DrawerEventsManagerService() {
        // child *-case components publish event after initialize
        // shell component subscribe to receive that data
        this.onInitComplete = new Subject_1.Subject();
        // child *-case components publish saved data
        // shell component subscribe to receive that data
        this.onSaveComplete = new Subject_1.Subject();
        // shell component publish save event to child *-case components
        // child *-case components subscribe to receive save instruction
        this.onSaveTrigger = new Subject_1.Subject();
    }
    DrawerEventsManagerService = __decorate([
        core_1.Injectable()
    ], DrawerEventsManagerService);
    return DrawerEventsManagerService;
}());
exports.DrawerEventsManagerService = DrawerEventsManagerService;
//# sourceMappingURL=drawer-events-manager.service.js.map